export default __webpack_public_path__ + "static/media/worker_oilgaz.dad75f3a.jpg";